import { TranslateModifiers } from '@core/translate';
import { Component } from '@rhtml/component';
import { css, html, LitElement, property, TemplateResult } from '@rxdi/lit-html';
import { combineLatest, Observable } from 'rxjs';

import { DropdownCSS } from './dropdown.css';

/**
 * @customElement info-menu
 */
@Component<TemplateResult[], null, InfoMenuComponent>({
  Settings: {
    selector: 'info-menu',
    modifiers: [...TranslateModifiers],
    style: css`
      .container {
        width: 100%;
      }
      h3 {
        color: hsl(0deg 0% 80%);
        text-align: left;
        font-weight: 100;
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: left;
      }

      li {
        /* padding: 20px; */
        padding-left: 0px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.03);
        font-weight: 100;
      }
      .flex {
        display: flex;
      }
      .spacer {
        flex: 1 3 auto;
      }

      .arrow {
        border: solid black;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 6px;
      }

      .absolute {
        position: absolute;
      }

      .down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }

      .options {
        cursor: pointer;
        user-select: none;
        padding: 15px;
      }

      .options:hover {
        background: rgba(0, 0, 0, 0.03);
      }

      .title {
        padding: 15px 15px 15px 0px;
      }

      .arrow-container {
        padding-right: 15px;
      }
      ${DropdownCSS}
    `,
  },
  State(this) {
    return combineLatest([...this.menus.map((m) => m())]);
  },
  Render: () => (state) => {
    return html`
      <ul class="container">
        ${state?.map(
          (template) => html`
            <li>
              <div class="flex">${template}</div>
            </li>
          `
        )}
      </ul>
    `;
  },
})
export class InfoMenuComponent extends LitElement {
  @property({ type: Array })
  menus: (() => Promise<TemplateResult> | Observable<TemplateResult>)[] = [];
}
